module.exports = __webpack_public_path__ + "static/media/p16b.0ccf50b9.ogg";